// extracted by mini-css-extract-plugin
var _1 = "OtherKeySites_OtherKeySites__YXbw1";
var _2 = "OtherKeySites_card__K0vcf";
var _3 = "OtherKeySites_contentContainer__ebgXs";
var _4 = "OtherKeySites_icon__g32Xz";
var _5 = "OtherKeySites_itemTitle__xRBsW";
var _6 = "OtherKeySites_keySiteTitle__IVJwi";
var _7 = "OtherKeySites_slide__VWyCp";
var _8 = "OtherKeySites_swiper__27n1J";
var _9 = "OtherKeySites_title__RHfRV";
export { _1 as "OtherKeySites", _2 as "card", _3 as "contentContainer", _4 as "icon", _5 as "itemTitle", _6 as "keySiteTitle", _7 as "slide", _8 as "swiper", _9 as "title" }
